import React, { useState, useEffect } from "react";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import apiService from "../../services/apiService";

const NewSlot = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState({
    channel_id: "",
    name: "",
    description: "",
    start_time: "",
    end_time: "",
  });
  const [channels, setChannels] = useState([]);

  // Fetch the channels list when the component mounts
  useEffect(() => {
    const fetchChannels = async () => {
      try {
        const response = await apiService.fetchData("admin/channels");
        setChannels(response.data); // Assuming the API returns an array of channels
      } catch (error) {
        console.error("Error fetching channels:", error);
      }
    };

    fetchChannels();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContent({ ...content, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    for (const key in content) {
      formData.append(key, content[key]);
    }

    try {
      const response = await apiService.postData("admin/slot", formData);
      console.log("Upload successful:", response);
      navigate("/radio");
    } catch (error) {
      console.error("Error uploading content:", error);
    }
  };

  return (
    <div className="row">
      <div className="col-12 col-md-12">
        <div className="card">
          <div className="card-header">
            <h4>New Slot</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Channel</label>
                <select
                  className="form-control"
                  name="channel_id"
                  value={content.channel_id}
                  onChange={handleChange}
                >
                  <option value="">Select Channel</option>
                  {channels.map((channel) => (
                    <option key={channel.channel_id} value={channel.channel_id}>
                      {channel.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Show Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={content.name}
                  onChange={handleChange}
                  placeholder="Enter Show Name"
                />
              </div>

              <div className="form-group">
                <label>Show Description</label>
                <textarea
                  name="description"
                  className="form-control"
                  value={content.description}
                  onChange={handleChange}
                  placeholder="Enter Show Description"
                ></textarea>
              </div>

              <div className="form-group">
                <label>Start Time</label>
                <input
                  type="time"
                  name="start_time"
                  className="form-control"
                  value={content.start_time}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>End Time</label>
                <input
                  type="time"
                  name="end_time"
                  className="form-control"
                  value={content.end_time}
                  onChange={handleChange}
                />
              </div>

              <div className="d-flex gap-2 mt-3">
                <button type="submit" className="btn btn-primary">
                  <Plus size={16} /> Add Slot
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/radio")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewSlot;
